import React from 'react';
//import { Col, Container, Row } from '@gjensidige/core-grid';
import { Flex } from '@gjensidige/builders-components';
import '../InsuranceStep/InsuranceStep';
import PriceCalculationContainer from '../../../containers/PriceCalculationContainer';
interface ComponentProps {
  productName: string;
}

const PriceCalculationStep: React.FC<ComponentProps> = (props) => {
  return props.productName === 'mc' || props.productName === 'car' || props.productName === 'home' ? (
    <Flex center="md" layout="1" style={{ marginTop: "40px" }}>
      {/* <Row> */}
      <PriceCalculationContainer productName={props.productName} />
      {/* </Row> */}
    </Flex>
  ) : (
    <Flex center="md" layout="1" style={{ marginTop: "40px" }}>
      {/* <Row noGutters className="justify-content-center my-1">
        <Col md="12" sm="12"> */}
      Not a Valid product, please choose a valid product
      {/* </Col>
      </Row> */}
    </Flex>
  );
};

export default PriceCalculationStep;
